import React from 'react';
import { DialogContent, DialogTitle } from '@material-ui/core';
import { useCallbackRef } from '../hooks';
import Dialog from '../dialogs/components/Dialog';
import FranchiseUrlForm from './FranchiseUrlForm';
import DialogFormActions from '../dialogs/components/DialogFormActions';
import { IdPropType } from '../../proptypes/basic';

const FranchiseUrlDialog = ({onClose, locationId, franchiseUrlId}) => {
    const ref = useCallbackRef();

    return (
        <Dialog fullWidth maxWidth="md">
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Neue Franchisepartner Webseite</DialogTitle>

            <DialogContent>
                <FranchiseUrlForm 
                    locationId={locationId}
                    franchiseUrlId={franchiseUrlId}
                    onDone={onClose}
                    submitRef={ref}
                />
            </DialogContent>

            <DialogFormActions ref={ref} />
        </Dialog>
    );
};

FranchiseUrlDialog.propTypes = {
    locationId: IdPropType,
    franchiseUrlId: IdPropType,
};

FranchiseUrlDialog.defaultProps = {
    locationId: null,
    franchiseUrlId: null,
};

export default FranchiseUrlDialog;
